if($("#contact-form").length>0) {
    $("#contact-form form").validate({
        rules: {
            first_name: {
                required: true
            },
            last_name: {
                required: true
            },
            email: {
                email: true
            },
            privacy: {
                required: true
            },
        },
        messages: {
            first_name: "Campo obbligatorio",
            last_name: "Campo obbligatorio",
            email: "Campo obbligatorio",
            privacy: "Campo obbligatorio",
        }
    });
}


if($(".form-newsletter").length>0) {
    $(".form-newsletter form").validate({
        rules: {
            first_name: {
                required: true
            },
            last_name: {
                required: true
            },
            company_name: {
                required: true
            },
            email: {
                email: true
            },
            privacy: {
                required: true
            },
        }
    });
}

if($("#simple-form").length>0) {
    $("#simple-form form").validate({
        rules: {
            first_name: {
                required: true
            },
            last_name: {
                required: true
            },
            email: {
                email: true
            },
            privacy: {
                required: true
            },
        }
    });
}
if($("#get_quote").length>0) {
    $("#get_quote form").validate({
        rules: {
            first_name: {
                required: true
            },
            last_name: {
                required: true
            },
            email: {
                email: true
            },
            privacy: {
                required: true
            },
        }
    });
}

if($("#rma_form").length>0) {
    $('#s_n').tagsinput({
        delimiter: ','
    });
    var tags = $('input#tags').tagsinput({
        delimiter: ','
    });
    $("#rma_form form").validate({
        rules: {
            s_n: {
                required: true
            },
            p_n: {
                required: true
            },
            first_name: {
                required: true
            },
            last_name: {
                required: true
            },
            email: {
                email: true
            },
            telephone: {
                required: true
            },
            privacy: {
                required: true
            },
        }
    });
}


if($(".popup-mask-login").length>0) {
    $(".popup-mask-login form").validate({
        rules: {
            email: {
                email: true
            },
            privacy: {
                required: true
            },
        }
    });
}

$(window).scroll(function() {
    if ($(this).scrollTop() > 350) {
        $('.scroll-top').fadeIn();
    }else{
        $('.scroll-top').fadeOut();
    }
});

$("input[type='number']").inputSpinner();


$('.scroll-top').click(function (e) {
    e.preventDefault();
    $("html, body").animate({scrollTop:0}, 'slow');
})

$('.goToSection').click(function (e){
    e.preventDefault();
    let scrollPos = $(this).data('section');
    $("html, body").animate({scrollTop:$('#'+scrollPos).offset().top - $('header').innerHeight() }, 'slow');
})

/*var lastScrollTop = 0;
var waitEndScroll = 0;
$(window).scroll(function(event){
    if($(window).width()>1024) {
        var st = $(this).scrollTop();
        if (st > 200) {
            $('html').addClass('scrolled');
        } else {
            if (st == 0) {
                $('html').removeClass('scrolled');
                header.removeClass('fixed');
            }
        }
        let header = $('header');
        if (st > lastScrollTop) {
            // downscroll code
            clearInterval(waitEndScroll);
            header.removeClass('fixed');
            header.css({'top': st + 'px'});
            waitEndScroll = setTimeout(function () {
                clearInterval(waitEndScroll);
                header.css({'top': st + 'px'});
            }, 1500);
        } else {
            // upscroll code
            header.addClass('fixed');
            header.css({'top': st + 'px'});
        }
        lastScrollTop = st;
    }
});*/

$('.hamburger').click(function() {
    $(this).toggleClass("is-active");
    $('nav').toggleClass("open");
    $('.submenu').removeClass('open');
});

if($("#info-msg").length>0) {
    $('#info-msg').show(function () {
        $(".chiudi").click(function(e){
            e.preventDefault();
            $('#info-msg').hide();
            $('.overlay-popup').hide();
        })
    });
}

var Sticky = require('sticky-js/src/sticky');
var sticky = new Sticky('.sidebar-navigation-product');
var stickySidebar = new Sticky('.simple-sidebar');

var sections = $('.block-content-navigation'),
    nav = $('.sidebar-navigation-product');

$(window).on('scroll', function () {
    var cur_pos = $(this).scrollTop();
    sections.each(function() {
        var top = $(this).offset().top-100,
            bottom = top + $(this).outerHeight();

        if (cur_pos >= top && cur_pos <= bottom) {
            nav.find('li').removeClass('active');
            sections.removeClass('active');

            $(this).addClass('active');
            nav.find('a[href="#'+$(this).attr('id')+'"]').parent().addClass('active');
        }
    });
});
nav.find('a').on('click', function (e) {
    e.preventDefault();
    var $el = $(this), id = $el.attr('href');

    $('html, body').animate({
        scrollTop: $(id).offset().top - 20
    }, 500);
});

    var $grid_portfolio = $('.grid').isotope({
        itemSelector: '.grid-item'
    });

    if(window.location.hash) {
        var filterUrl = window.location.hash.replace( /#/, "." )
        $('.single-filter').parent().removeClass('active');
        $(filterUrl).parent().addClass('active');
        var filterValue = $(filterUrl).attr('data-filter');
        var grid = $grid_portfolio.isotope({filter: filterValue});
        grid.on('arrangeComplete', checkElementVisible);
        stickySidebar.update();
    }

    $(document).on('click', '.single-filter', function (e) {
        e.preventDefault();
        $('.single-filter').parent().removeClass('active');
        $(this).parent().addClass('active');
        var filterValue = $(this).attr('data-filter');
        var grid = $grid_portfolio.isotope({filter: filterValue});
        grid.on('arrangeComplete', checkElementVisible);
        stickySidebar.update();
        if ($(window).width() < 768) {
            $('html, body').animate({
                scrollTop: $('.list-casehistory, .grid-product').offset().top - 150
            }, 250);
        }
    });

function checkElementVisible() {
    if ($('.grid-item:visible').length > 0) {
        $('.no-casehistory').hide();
    } else {
        $('.no-casehistory').show();
    }
}

$("#temporary_code").mask("9 9 9 9 9 9", {placeholder:" "});
$('.row-modal-login').find('input.form-control').each(function (){
    $(this).focusout(function() {
        if($(this).val()!=''){
            $(this).addClass('not-empty')
        }else{
            $(this).removeClass('not-empty')
        }
    });
});

$('#send-contact').click(function (e){
    $('.ico-send-modal').show();
    setTimeout(function (){
        if($(".popup-mask-login").find('.error').length>0) {
            $('.ico-send-modal').hide();
        }
    },250);
});

$('.popup-mask-login').find('.cta-link').click(function (){
    $('.ico-send-modal').show();
    setTimeout(function () {
        if($(".popup-mask-login").find('.error').length>0) {
            $('.ico-send-modal').hide();
        }else {
            $('.overlay-popup').trigger('click');
        }
    },500);
})

$('.link-download-file').click(function (e){
    e.preventDefault();
    $('.modal_download').addClass('show-modal');
    // check step registrazione
    $('.popup-mask-login').show().delay(500).addClass('show-step');
});
$('.overlay-popup').click(function (){
    $('.modal_download').removeClass('show-modal');
    $('#mask-step1, #mask-step2').removeClass('show-step');
});



if($('form').length>0){
    $('[data-toggle="tooltip"]').tooltip();
}

if($('.fake-select').length>0){
    $('.fake-select').find('select').change(function (){
        let urlDestination = $(this).val();
        window.location.href = urlDestination;
    });
}

$('.switch-order').find('a').each(function (){
    $(this).click(function (e) {
        e.preventDefault();
        let orderClass = $(this).attr('id');
        let orderTitle = $(this).data('title');
        let orderType = $(this).data('type');
        $(this).parents('.switch-order').removeClass('arch partner');
        $('.submenu-'+orderType).hide();
        $('#'+orderType+'-'+orderClass).show();
        $(this).parents('.switch-order').addClass(orderClass);
        $('#type-'+orderType).html(orderTitle);
    });
});

$('.submenu > a').click(function (e){
    e.preventDefault();
    if($(this).parent('.submenu').hasClass('open')){
        $('.submenu').removeClass('open');
    }else {
        $('.submenu').removeClass('open');
        $(this).parent().addClass('open');
    }
})

$(document).on('click', function (event) {
    if (!$(event.target).closest('header').length) {
        $('.submenu').removeClass('open');
    }
});

$('.tit-menu-footer').click(function (e){
    $('.footer-nav').find('ul').removeClass('open');
    $(this).parent().find('ul').addClass('open');
})

$(".owl-carousel").owlCarousel({
    loop:true,
    margin:30,
    responsiveClass:true,
    responsive:{
        0:{
            items:1,
            nav:false,
            dots:true
        },
        600:{
            items:3,
            nav:false,
            loop:false
        }
    }
});


var vid = document.getElementById("bgvid");
if($('#bgvid').length>0) {
    window.onload = startVideo;
}

function startVideo() {
    vid.play();
}

/* FAQ */
if($('.faq-list').length){
    $('.domanda-faq').each(function () {
        $(this).click(function (){
            if($(this).parent().hasClass('open')){
                $('.singola-faq').removeClass('open');
                $('.risposta-faq').slideUp();
            }else{
                $('.singola-faq').removeClass('open');
                $('.risposta-faq').slideUp();
                $(this).parent().addClass('open');
                $(this).parent().find('.risposta-faq').slideDown();
                stickySidebar.update();
            }
        })
    })

    $('.single-filter-faq').click(function (){
        let level = $(this).data('level');
        let categoryFaq = $(this).data('faq');
        /*console.log(categoryFaq);
        console.log(level);*/
        $('.singola-faq').removeClass('open');
        $('.risposta-faq').slideUp();
        if(categoryFaq == '*'){
            $('.category-faq').parent().removeClass('active');
            $('.subcategory-faq').parent().removeClass('active');
            $(this).parent().addClass('active');
            $('.title-category-faq').show();
            $('.content-category-faq').show();
            $('.content-subcategory-faq').show();
            $('.singola-faq').show();
        }else {
            if (level == 'category') {
                $('.category-faq').parent().removeClass('active');
                $('.subcategory-faq').parent().removeClass('active');
                $(this).parent().addClass('active');
                $('.content-subcategory-faq').hide();
                $('.content-category-faq').hide();
                $('.risposta-faq').hide();
                $('.title-category-faq').hide();
                $('#' + categoryFaq).show();
                $('#' + categoryFaq).find('.singola-faq').show();
                $('#' + categoryFaq).find('.content-subcategory-faq').show();
                $('#' + categoryFaq).find('.title-category-faq').show();
            } else {
                $('.singola-faq').hide();
                $('.title-category-faq').hide();
                $('.subcategory-faq').parent().removeClass('active');
                $(this).parent().addClass('active');
                $('#' + categoryFaq).find('.singola-faq').show();
                $('#' + categoryFaq).find('.title-category-faq').show();
            }
        }
        stickySidebar.update();
    })
}


$('.has-submenu').click(function (e){
    $('.has-submenu').removeClass('show');
    $(this).addClass('show');
});
$(document).on('click', function (event) {
    if (!$(event.target).closest('header').length) {
        $('.has-submenu').removeClass('show');
    }
});
